import { z } from "zod"

import { CompanyEquipment, CompanyIndustry, CompanyMarket } from "@/graphql/codegen/graphql"
import {
  COMPANY_INFO_TEXT_AREA_ERROR_MESSAGE,
  COMPANY_INFO_TEXT_AREA_MAX_SIZE,
} from "@/screens/Companies/edit/components/info/constants"

export const CompanyInfoFormSchema = z.object({
  industry: z.array(z.nativeEnum(CompanyIndustry)),
  equipment: z.array(z.nativeEnum(CompanyEquipment)),
  market: z.array(z.nativeEnum(CompanyMarket)),
  generalInfo: z
    .string()
    .max(COMPANY_INFO_TEXT_AREA_MAX_SIZE, { message: COMPANY_INFO_TEXT_AREA_ERROR_MESSAGE })
    .optional(),
  marketingPotential: z
    .string()
    .max(COMPANY_INFO_TEXT_AREA_MAX_SIZE, { message: COMPANY_INFO_TEXT_AREA_ERROR_MESSAGE })
    .optional(),
  technicalCapabilities: z
    .string()
    .max(COMPANY_INFO_TEXT_AREA_MAX_SIZE, { message: COMPANY_INFO_TEXT_AREA_ERROR_MESSAGE })
    .optional(),
  productionCapabilities: z
    .string()
    .max(COMPANY_INFO_TEXT_AREA_MAX_SIZE, { message: COMPANY_INFO_TEXT_AREA_ERROR_MESSAGE })
    .optional(),
  reputation: z
    .string()
    .max(COMPANY_INFO_TEXT_AREA_MAX_SIZE, { message: COMPANY_INFO_TEXT_AREA_ERROR_MESSAGE })
    .optional(),
})

export type CompanyInfoFormValues = z.infer<typeof CompanyInfoFormSchema>
